import { ApartmentInfo } from '../apartment-info';
import { starLeadForm } from '../../config/icons';
import { TPolygon, TLead, TProject } from '../../types/config';
import { Box, Divider, Paper, Stack, Typography, useTheme } from '@mui/material';
import { SxProps } from '@mui/material';

export type StickyInfoAndFormProps = {
  top?: number;
  onSent: (lead: TLead) => void;
  onClose: () => void;
  project?: TProject;
  apartmentLanding?: TPolygon;
  t: (key: string) => string;
  sx?: SxProps;
  children?: React.ReactNode;
};
export function StickyInfoAndForm({
  top,
  project,
  apartmentLanding,
  t,
  sx = {},
  children,
}: StickyInfoAndFormProps) {
  const { palette } = useTheme();

  console.log('project', project);

  return (
    <Stack
      component={Paper}
      elevation={1}
      sx={{
        position: 'sticky',
        top: `${top}px`,
        borderRadius: '12px',
        border: `1px solid ${palette.grey[200]}`,
        background: '#fff',
        ...sx,
      }}
    >
      {!!project?.promotions && (
        <Stack
          direction="row"
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{
            padding: '10px 15px',
            borderBottom: '1px solid #EAECF0',
            backgroundColor: 'grey.100',
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
          }}
        >
          <Typography variant="subtitle2" sx={{ opacity: 0.9 }}>
            {t('labels.nowOnSale')}
          </Typography>
          {starLeadForm}
        </Stack>
      )}

      <Stack padding={{ xs: '16px 16px 0 16px ', sm: '20px' }} direction="column" spacing={1}>
        <Stack direction="column" spacing={2}>
          {project?.logoUrl && (
            <Box width="100%" overflow="hidden">
              <img
                src={project?.logoUrl}
                style={{
                  objectFit: 'contain',
                  maxWidth: 'fit-content',
                  height: '60px',
                  width: '250px',
                }}
              />
            </Box>
          )}
          <Stack direction="column" spacing={1}>
            <Typography variant="h4" sx={{ opacity: 0.9 }}>
              {project?.title}
            </Typography>
            <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
              {project?.address}
            </Typography>
            {/* <PriceRange project={project} /> */}
            {/* {(apartmentLanding && !!apartmentLanding.price) && (
              <Typography variant="h6" color="info.main" style={{ whiteSpace: 'break-spaces' }}>
                {t('labels.fromPrice', { v: apartmentLanding.price })}
              </Typography>
            )} */}
          </Stack>
        </Stack>
        <ApartmentInfo t={t} apartmentLanding={apartmentLanding} />
        <Stack direction="column" spacing={1}>
          <Divider style={{ width: '100%' }} />
          <Typography variant="subtitle2" sx={{ opacity: 0.9, whiteSpace: 'pre-wrap' }}>
            {project?.isYzer ? t('labels.forFurtherInfoIsYzer') : t('labels.forFurtherInfo')}
          </Typography>
        </Stack>
        {children}
      </Stack>
    </Stack>
  );
}
